export default "__VITE_ASSET__B4P37KNr__"